export default "__VITE_ASSET__BWT24GC$__";